const translations = {
  'onlineCerttesol.seo.title': '100% Online TEFL Course in Spain | Trinity CertTESOL',
  'onlineCerttesol.seo.description': `Qualify as a TEFL teacher online and starting working immediately after the course. Affordable, supportive and run in small groups. `,
  'onlineCerttesol.sec1.title': 'Part-Time Online Trinity CertTESOL Course',
  'onlineCerttesol.sec1.description':
    'Complete the prestigious, internationally recognised course online in 12 weeks',
  'onlineCerttesol.sec1.weeks': '12 weeks',
  'onlineCerttesol.sec1.hours': '160-hour course',
  'onlineCerttesol.sec1.cities': 'Barcelona & Seville',
  'onlineCerttesol.sec2.title': 'Combine Study With Your Current Job',
  'onlineCerttesol.sec2.description':
    'The 100% online Trinity CertTESOL course allows you to train and qualify in 12 weeks, without the need to quit your job or move abroad. With this internationally recognised qualification you’ll be prepared and qualified to find work both online and in person at language academies.',
  'onlineCerttesol.sec2.benefitsTitle': 'This course is ideal for you if:',
  'onlineCerttesol.sec2.benefit1': 'You want to combine study with a full-time job',
  'onlineCerttesol.sec2.benefit2':
    'You want to get an internationally recognised teaching qualification online.',
  'onlineCerttesol.sec2.benefit3': 'You enjoy online study.',
  'onlineCerttesol.sec2.benefit4':
    'You want to retrain and earn reliable income from a teaching job.',
  'onlineCerttesol.sec2.ben1.title': 'Internationally Recognized Qualification',
  'onlineCerttesol.sec2.ben1.text':
    'Barcelona? Bangkok? Brazil? Trinity CertTESOL is accepted across the globe.',
  'onlineCerttesol.sec2.ben2.title': '100% Online',
  'onlineCerttesol.sec2.ben2.text':
    'You’ll join live online sessions every week with the tutor and other students.',
  'onlineCerttesol.sec2.ben3.title': 'Small Group Sizes',
  'onlineCerttesol.sec2.ben3.text':
    'Our classes max out at 8, giving everybody access to an instructor.',
  'onlineCerttesol.sec2.ben4.title': 'Post-Grad Job Prospects',
  'onlineCerttesol.sec2.ben4.text':
    'We work hard to ensure that all our students find relevant work after graduation.',
  'onlineCerttesol.sec3.title': 'What’s Included?',
  'onlineCerttesol.sec3.benefit1': '160-hour Trinity CertTESOL course and qualification.',
  'onlineCerttesol.sec3.benefit2':
    'Expert tuition from professional teachers via video conferencing and discussion forums.',
  'onlineCerttesol.sec3.benefit3': 'Trinity CertTESOL examination and certificate fees.',
  'onlineCerttesol.sec3.benefit4': 'Course workbook sent to your home address.',
  'onlineCerttesol.sec3.benefit5': '6+ hours of observed teaching practice with real learners.',
  'onlineCerttesol.sec3.benefit6':
    'Job contacts and placement help – our host school hires exclusively from TEFL Iberia graduates.',
  'onlineCerttesol.sec3.benefit7': 'Dedicated course coordinator.',

  'onlineCerttesol.sec3.fullPrice': 'FULL PRICE:',
  'onlineCerttesol.sec3.earlyBirdPrice': 'EARLY BIRD PRICE:',
  'onlineCerttesol.sec3.payInFull': 'Pay in full 4 weeks in advance',
  'onlineCerttesol.sec3.quotation': `I had THE best time at TEFL Iberia. I didn't really know what to expect before starting the course and it turned out to be nothing but excellent. The course was very intense, but it was so well-structured and the whole staff was so professional and ready to go the extra mile, that in just a month I found myself perfectly able to teach English.`,

  'onlineCerttesol.internalSection.title':
    'What will the 100% Online Trinity CertTESOL <accent>be like?</accent>',
  'onlineCerttesol.internalSection.text1':
    'Our 100% Online Trinity CertTESOL course is done via Zoom and does not require any in-person training at all. Your workshops, lesson preparation, teaching practice and assignments will all be carried out online.',
  'onlineCerttesol.internalSection.text2':
    'The Trinity CertTESOL course will take part over 12 weeks, with 10 hours per week of live tutor time, plus 5 hours per week of self study and assignments. See below for more detailed information on the timetable.',
  'onlineCerttesol.internalSection.text3':
    'The timetable has been designed to cater for people who have full time work or study, and would like to combine their teacher training with other commitments.',

  'onlineCerttesol.sec8.title': 'Course Curriculum And Timetable',
  'onlineCerttesol.sec8.description':
    'The 100% Online Trinity CertTESOL course is 160 hours long and takes place over 12 weeks. <accent> The live tutor sessions take place on Tuesday, Wednesday and Thursdays. </accent> <accent2> There are two timetables available to cater for different time zones: </accent2>',
  'onlineCerttesol.sec8.notification.time1': '6pm - 9pm (EST - suitable for North Americans)',
  'onlineCerttesol.sec8.notification.time2': '6pm - 9pm (GMT - suitable for Europeans)',
};

export default translations;
